import * as React from "react";
import styled from "styled-components";
import { Button } from "components/bootstrap";
import timerangeToString from "views/logic/queries/TimeRangeToString";
import useUserDateTime from "hooks/useUserDateTime";
import TimeRangePickerButton from "views/components/time-range-picker/TimeRangePickerButton";
const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;
const TimeRangeInfo = styled.div(
  ({ theme }) => `
  margin-left: 10px;
  border: 1px dashed ${theme.colors.input.border};
  width: 100%;
  border-radius: 4px;
  padding: 0 5px;
  min-height: 34px;
`
);
const TimeRangeString = styled.div(
  ({ theme }) => `
  display: inline-block;
  margin-left: 0;
  margin-top: 5px;
  padding: 0 3px;
  border-radius: 4px;
  background-color: ${theme.colors.variant.lightest.primary};
  color: ${theme.colors.variant.darker.primary};
  font-size: ${theme.fonts.size.body};
  font-family: ${theme.fonts.family.monospace};
`
);
const ResetButton = styled(Button)`
  margin-top: 5px;
  margin-bottom: 5px;
  margin-left: 5px;
  display: inline-block;
  float: right;
`;
const WidgetTimeRangeOverride = ({ value, onReset }) => {
  const { formatTime } = useUserDateTime();
  const localTimeWithMS = timerangeToString(value, (dateTime) => formatTime(dateTime, "complete"));
  const internalTime = timerangeToString(value, (dateTime) => formatTime(dateTime, "internal"));
  return /* @__PURE__ */ React.createElement(Wrapper, null, /* @__PURE__ */ React.createElement(TimeRangePickerButton, { disabled: true }), /* @__PURE__ */ React.createElement(TimeRangeInfo, null, /* @__PURE__ */ React.createElement(TimeRangeString, { title: internalTime }, localTimeWithMS), /* @__PURE__ */ React.createElement(ResetButton, { bsSize: "xs", bsStyle: "primary", onClick: onReset, "data-testid": "reset-global-time-range" }, "Reset Global Override")));
};
export default WidgetTimeRangeOverride;
